module.exports = __webpack_public_path__ + "static/media/UploadSources.d38264db.svg";